const API_BASE_URLS = {
    GEOCODE: "http://localhost:8082/api/geocode",
    DEALERS: {
      FILTER: "http://localhost:8076/api/dealers/filter",
      PROXIMITY: "http://localhost:8081/api/proximity/nearby"
    },
    TEST_RIDE_BOOKING: "http://localhost:8008/api/testride/book-test-ride"
  };
  
  export default API_BASE_URLS;
  